import share from './core/components/share.vue'


export default share 


